import { RgDataSetID, RougeDataSets } from "@project-rouge/rg-core";

export const DatasetId = RgDataSetID.uk_01;
export const Dataset = RougeDataSets[DatasetId];
